/**
 * The privacy notice's editable text, browser copy of functions/src/employment/ccpaNotice.js
 * (noticeToText / textToBlocks / effectiveNotice). The live editor (/apply/form) turns the draft
 * into blocks on every keystroke; privacyNotice.test.js holds this to the server.
 *
 * One block per line: "## " starts a heading, "- " a bullet, anything else is a paragraph; blank
 * lines are ignored.
 */

const clean = (value) => String(value === undefined || value === null ? '' : value).trim();

export function noticeToText(blocks) {
  return (blocks || [])
    .map((block) =>
      block.type === 'heading' ? `## ${block.text}` : block.type === 'bullet' ? `- ${block.text}` : block.text
    )
    .join('\n');
}

export function textToBlocks(text) {
  return String(text || '')
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => {
      if (line.startsWith('## ')) return { type: 'heading', text: line.slice(3).trim() };
      if (line.startsWith('- ')) return { type: 'bullet', text: line.slice(2).trim() };
      return { type: 'paragraph', text: line };
    })
    .filter((block) => block.text);
}

/**
 * The notice a draft override describes, over the shipped one (`defaults`: { title, lastModified,
 * text }, from getApplicationSchema).
 */
export function draftNotice(override, defaults) {
  const own = override && typeof override === 'object' ? override : {};
  const blocks = clean(own.text) ? textToBlocks(own.text) : [];
  return {
    title: clean(own.title) || defaults.title,
    lastModified: clean(own.lastModified) || defaults.lastModified,
    blocks: blocks.length ? blocks : textToBlocks(defaults.text),
  };
}
